export enum paginationEnum {
  DISPLAYPAGESIZE = 10,
  FETCHPAGESIZE = 1000,
  PAGEINDEX = 0,
  FIVE = 5,
  TEN = 10,
  TWENTYFIVE = 25,
  HUNDRED = 100,
}